export const severities = [
  { key: 'appox', title: 'Appoxalypse', value: 4 },
  { key: 'critical', title: 'Critical', value: 3 },
  { key: 'high', title: 'High', value: 2 },
  { key: 'medium', title: 'Medium', value: 1 },
  { key: 'low', title: 'Low', value: 0 },
];

export const severitiesHeatMap = [
  { key: 'appox', title: 'Appoxalypse', value: 5 },
  { key: 'critical', title: 'Critical', value: 4 },
  { key: 'high', title: 'High', value: 3 },
  { key: 'medium', title: 'Medium', value: 2 },
  { key: 'low', title: 'Low', value: 1 },
  { key: 'info', title: 'Info', value: 0 },
];

export interface Severities {
  info: number;
  low: number;
  medium: number;
  high: number;
  critical: number;
  appox: number;
}
